/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import ContentLoader from "react-content-loader";
import Hidden from "@mui/material/Hidden";

export const BoxHeadingLoader = () => (
  <>
    <Hidden only={"xs"}>
      <ContentLoader height={80} width={500} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="90" y="25" rx="4" ry="4" width="200" height="10" />
        <circle cx="36" cy="36" r="36" />
      </ContentLoader>
    </Hidden>
    <Hidden smUp>
      <ContentLoader height={80} width={300} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="90" y="25" rx="4" ry="4" width="100" height="10" />
        <circle cx="36" cy="36" r="36" />
      </ContentLoader>
    </Hidden>
  </>
);
